/**
 * Shared overlay shown when bank accounts are linked.
 * Used by setupPage and performanceOnboardingBanner (via SetupFlowContent).
 */
import { Box, Button, Fade, Typography } from "@mui/material";

export default function SuccessOverlay({ open, onClose, setStepperStep }) {
  return (
    <Fade in={open} timeout={300} unmountOnExit>
      <Box
        sx={{
          fontFamily: "Rethink Sans",
          position: "fixed",
          top: 0,
          left: 0,
          width: "100vw",
          height: "100vh",
          backgroundColor: "rgba(0, 0, 0, 0.5)",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          zIndex: 2000,
        }}
      >
        <Box
          sx={{
            fontFamily: "Rethink Sans",
            backgroundColor: "background.paper",
            borderRadius: "12px",
            boxShadow: 8,
            padding: "32px 32px",
            textAlign: "center",
            width: "90%",
            maxWidth: "400px",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <Box
            component="img"
            src="/Success Animation.gif"
            alt="Setup Complete"
            sx={{
              width: { xs: "120px", sm: "160px" },
              height: "auto",
              objectFit: "contain",
            }}
          />
          <Typography
            variant="h6"
            fontSize={"1.5rem"}
            fontWeight={600}
            sx={{ fontFamily: "Rethink Sans" }}
          >
            ✅ You’re All Set!
          </Typography>
          <Typography
            variant="body2"
            fontSize={"16px"}
            sx={{
              mt: 1,
              mb: 3,
              fontFamily: "Rethink Sans",
              color: "text.secondary",
            }}
          >
            Your bank accounts are securely linked. Let’s put your financial
            data to work!
          </Typography>
          <Button
            variant="contained"
            color="primary"
            onClick={() => {
              onClose();
            }}
            sx={{
              textTransform: "none",
              px: "32px",
              py: "6px",
              borderRadius: "8px",
              "&:hover": { backgroundColor: "#4C63D7" },
            }}
          >
            Continue with Setup
          </Button>
        </Box>
      </Box>
    </Fade>
  );
}
